import { CheckCircle, Clock, XCircle, CircleAlert } from 'lucide-react';

import { COACH_ACTIVITY_STATUS } from '@/app/coachActivity/enums';

import { Badge } from '@/components/ui/badge';

const StatusBadge = ({ status }) => {
  switch (status) {
    case COACH_ACTIVITY_STATUS.APPROVED:
      return (
        <Badge className="bg-green-500 hover:bg-green-600">
          <CheckCircle className="mr-1 h-3 w-3" /> Approved
        </Badge>
      );
    case COACH_ACTIVITY_STATUS.PENDING:
      return (
        <Badge className="bg-yellow-500 hover:bg-yellow-600">
          <CircleAlert className="mr-1 h-3 w-3" /> Incomplete
        </Badge>
      );
    case COACH_ACTIVITY_STATUS.SUBMITTED:
      return (
        <Badge className="bg-blue-500 hover:bg-blue-600">
          <Clock className="mr-1 h-3 w-3" /> Submitted
        </Badge>
      );
    case COACH_ACTIVITY_STATUS.REJECTED:
      return (
        <Badge className="bg-red-500 hover:bg-red-600">
          <XCircle className="mr-1 h-3 w-3" /> Rejected
        </Badge>
      );
    default:
      return null;
  }
};

export default StatusBadge;
